// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TyyYg","title":"styles_title__80_Ac"};